import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-branches',
  templateUrl: './branches.component.html',
  styleUrls: ['./branches.component.css']
})
export class BranchesComponent implements OnInit {
  filteredMembers = [
    {
      "SNo": 1,
      "Branch": "Secunderabad",
      "ContactPerson": "Ajay Shekar",
      "MobileNumber": "9876678998",
      "EmailId": "sec.styleinteriors@gmail.com",
      "DateAdded": "23.01.2025",
      "Remarks": "Active"
    },
    {
      "SNo": 2,
      "Branch": "Kompally",
      "ContactPerson": "Nirupama",
      "MobileNumber": "9700180991",
      "EmailId": "kom.styleinteriors@gmail.com",
      "DateAdded": "22.02.2025",
      "Remarks": "Active"
    },
    {
      "SNo": 3,
      "Branch": "Gachibowli",
      "ContactPerson": "Saresh Kumar",
      "MobileNumber": "9494232343",
      "EmailId": "gac.styleinteriors@gmail.com",
      "DateAdded": "12.03.2025",
      "Remarks": "Active"
    },
    {
      "SNo": 4,
      "Branch": "LB Nagar",
      "ContactPerson": "Bhoopathi Naidu",
      "MobileNumber": "9876543210",
      "EmailId": "lbn.styleinteriors@gmail.com",
      "DateAdded": "02.04.2025",
      "Remarks": "Active"
    },
    {
      "SNo": 5,
      "Branch": "Kukatpally",
      "ContactPerson": "Chandrakanth",
      "MobileNumber": "9823983456",
      "EmailId": "kp.styleinteriors@gmail.com",
      "DateAdded": "21.05.2025",
      "Remarks": "Active"
    }
  ]
  
  constructor() { }

  ngOnInit(): void {
  }

}
